import React, { useState } from "react";
import CourseStoreStyle from "./style";
import TabsList from "../../Reusable/Tabs";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Input,
  Radio,
  Row,
} from "antd";
import courseImg from "../../../assets/Icons/course-img.png";
import { SearchOutlined, InfoCircleOutlined, ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import ViewCourse from "./ViewCourse";

const CourseStore = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [courseData, setCourseData] = useState();
  const items = [
    {
      id: "1",
      label: "TalentLibrary™",
      component: <></>,
    },
  ];

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const text = (
    <>
      <Checkbox>Business Continuity Applied(5)</Checkbox>
      <Checkbox>Business Continuity Essentials(5)</Checkbox>
      <Checkbox>Coaching Applied(5)</Checkbox>
    </>
  );

  const CourseData = [
    {
      id: 1,
      CourseCode: "A001",
      CourseName: "What is Artificial Intelligence?",
      spanContent: "Technology / Artificial Intelligence Essentials",
    },
    {
      id: 2,
      CourseCode: "A002",
      CourseName: "What is Artificial Intelligence?",
      spanContent: "Technology / Artificial Intelligence Essentials",
    },
    {
      id: 3,
      CourseCode: "A003",
      CourseName: "What is Artificial Intelligence?",
      spanContent: "Technology / Artificial Intelligence Essentials",
    },
    {
      id: 4,
      CourseCode: "A004",
      CourseName: "What is Artificial Intelligence?",
      spanContent: "Technology / Artificial Intelligence Essentials",
    },
  ];

  const SortByitems = [
    {
      key: '1',
      label: "Name"
    },
    {
      key: '2',
      label: "Date"
    },
  ]

  const [courseCardSort, setCourseCardSort] = useState("Name")
  const [courseCardSortIcon, setCourseCardSortIcon] = useState(false)

  const handleClickCourse = (data) => {
    console.log("data---->", data);
    setCourseData(data);
  };

  const handleSortMenuClick = (e) => {
    const selectedLabel = SortByitems.find(item => item.key === e.key)?.label;
    setCourseCardSort(selectedLabel || "Name");
  }

  return (
    <>
      <CourseStoreStyle>
        {courseData ? (
          <ViewCourse courseData={courseData} setCourseData={setCourseData} />
        ) : (
          <>
            <h1 className="user-menu-title">Course store</h1>

            <TabsList
              items={items}
              handleTabSelect={handleTabSelect}
              activeKey={activeTab}
            />

            <Row className="users-menu-filter-container">
              <Col>
                <Form.Item label="Sort By" name="Sort By" className="search-input-field">
                  <Dropdown
                    menu={{
                      items: SortByitems,
                      onClick: handleSortMenuClick,
                    }}
                    placement="bottom"
                    arrow={{
                      pointAtCenter: true,
                    }}
                    className="sort_by_dropdown"
                  >
                    <Button>{courseCardSort}</Button>
                  </Dropdown>
                </Form.Item>
              </Col>
              <Col>
                <Button className="sort_by_dropdown" onClick={() => setCourseCardSortIcon(!courseCardSortIcon)}>
                  {courseCardSortIcon ? <ArrowUpOutlined /> : <ArrowDownOutlined /> }
                </Button>
              </Col>
              <Col>
                <Form.Item name="search" className="search-input-field course_card_search">
                  <Input suffix={<SearchOutlined />} placeholder="Search" />
                </Form.Item>
              </Col>
            </Row>
            <br></br>
            <div className="subscribe_banner">
              <p>
                <InfoCircleOutlined /> Subscribe to TalentLibrary and get access
                to courses below.
              </p>
              <Button>Upgrade now</Button>
            </div>

            <br></br>

            {activeTab === "1" && (
              <>
                <Row className="collections-data-container">
                  <Col xl={6}>
                    <div>
                      <h2 className="collection_title">Collections</h2>

                      <div>
                        <Collapse
                          className="course_store_collapse"
                          items={[
                            {
                              key: "1",
                              label: (
                                <Checkbox
                                  onClick={(e) => e.stopPropagation()}
                                  className="collaple_checkbox_header"
                                >
                                  Business Skills (227)
                                </Checkbox>
                              ),
                              children: (
                                <p className="children_checkbox_collection">
                                  {text}
                                </p>
                              ),
                            },
                          ]}
                        />
                      </div>
                    </div>

                    <Divider />

                    <div className="languages-section">
                      <h2 className="collection_title">languages</h2>
                      <Form.Item
                        name="englsih"
                        valuePropName=""
                        className="checkbox_form"
                      >
                        <Radio>English</Radio>
                      </Form.Item>
                      <Form.Item
                        name="spanish"
                        valuePropName=""
                        className="checkbox_form"
                      >
                        <Radio>Spanish</Radio>
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xl={18}>
                    <div className="course-card-box-container">
                      {CourseData.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <div
                              className="course-card-box"
                              onClick={() => handleClickCourse(item)}
                            >
                              <img
                                src={courseImg}
                                className="Course-image-poster"
                                alt="Course-image-poster"
                              />
                              <p>{item.CourseCode}</p>
                              <p>{item.CourseName}</p>
                              <Button className="view-more-button">
                                view More
                              </Button>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </CourseStoreStyle>
    </>
  );
};

export default CourseStore;
